import * as React from 'react';

import { InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';

import { confirmForgotPassword } from 'actions/account';
import { requestResend } from 'actions/otp';
import { FieldText, InputText } from 'components/Input';
import { OtpPage } from 'components/OtpPage';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'constants/analytics';
import { APPLICATION_FORM_NAME } from 'constants/app';
import { sendEvent } from 'helper/analytics';
import { injectIntl } from 'helper/redux';
import { validate } from 'helper/validation/otp/otpForgotPasswordForm';
import { AccountForgotPasswordOtpForm } from 'models/account';
import { AppState } from 'models/app';
import { OtpForgotPasswordForm } from 'models/otp';

import './AccountForgotPasswordOtp.scss';

interface StateProps {
  phone: string;
}

interface DispatchProps {
  confirmForgotPassword: typeof confirmForgotPassword;
  requestResend: typeof requestResend;
}

type OwnProps = InjectedIntlProps & RouteComponentProps<{}>;
type AccountForgotPasswordOtpProps = StateProps & DispatchProps & OwnProps;

@injectIntl()
class AccountForgotPasswordOtpContainer extends React.Component<AccountForgotPasswordOtpProps, {}> {
  constructor(props: AccountForgotPasswordOtpProps) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onResendOtp = this.onResendOtp.bind(this);
  }

  render() {
    const { history, intl, location, phone } = this.props;

    if (!phone) {
      return <Redirect to="/"/>;
    }

    return (
      <OtpPage
        form={APPLICATION_FORM_NAME}
        history={history}
        location={location}
        onResendOtp={this.onResendOtp}
        onClose={history.goBack}
        onSubmit={this.onSubmit}
        phone={phone}
        validate={validate}
      >
        <FieldText
          name="newPassword"
          component={InputText}
          type="password"
          label={intl.formatMessage({ id: 'otp.forgot.password.new.password' })}
          footnote={intl.formatMessage({ id: 'form.footnote.valid.password.format' })}
          modifier="visibility"
          className="o-form-field"
        />
      </OtpPage>
    );
  }

  private onResendOtp() {
    const { phone } = this.props;

    sendEvent({
      action: AnalyticsEventAction.OTP_RESEND,
      category: AnalyticsEventCategory.ACCOUNT_FORGOT_PASSWORD_OTP
    });

    this.props.requestResend(phone);
  }

  private onSubmit(formValue: OtpForgotPasswordForm) {
    const { phone } = this.props;
    const fullFormValue: AccountForgotPasswordOtpForm = { ...formValue,  phone };

    sendEvent({
      action: AnalyticsEventAction.OTP_CONFIRM,
      category: AnalyticsEventCategory.ACCOUNT_FORGOT_PASSWORD_OTP
    });

    this.props.confirmForgotPassword(fullFormValue);
  }
}

export const AccountForgotPasswordOtp = connect<StateProps, DispatchProps, OwnProps>(
  (state: AppState) => ({
    phone: state.accountState.tempAccount.phone
  }), { confirmForgotPassword, requestResend }
)(AccountForgotPasswordOtpContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/ForgotPassword/AccountForgotPasswordOtp/AccountForgotPasswordOtp.tsx